<template>
<section>
<a-carousel autoplay arrows effect="fade">
    <template v-slot:prevArrow>
    <div
      class="custom-slick-arrow"
      style="left: 10px;z-index: 12"
    >
      <leftCircleTwoTone />
    </div>
    </template>
    <template v-slot:nextArrow>
    <div class="custom-slick-arrow" style="right: 10px">
      <rightCircleTwoTone />
    </div>
    </template>
    <div><img src="@/assets/products/wagyu/slider1.jpg"  /></div>
    <div><img src="@/assets/products/wagyu/slider2.jpg"  /></div>
    <div><img src="@/assets/products/wagyu/slider3.jpg"  /></div>
    <div><img src="@/assets/products/wagyu/slider4.jpg"  /></div>
    <div><img src="@/assets/products/wagyu/slider5.jpg"  /></div>
</a-carousel>
<div>
  <a-card title="和牛 の 常陆牛" bodyStyle="font-size:20px; text-align:left;" headStyle="font-size:24px;color:#904555;">
    <img src="@/assets/products/wagyu/wagyu5.jpg" style="width:100%;" />
  </a-card>
  <a-card>
    <template v-slot:title>
      <p style="text-align:left;font-weight:800;margin-bottom:0;">Message from the breeder:</p>
    </template>
    <p style="text-align:left;">We, Ibaraki Prefecture Chikuren Pilot Farm, are a training farm of the Federation of Ibaraki Livestock Agricultural Cooperatives. We play a role as an organization for better Production of cows and management. We have career veterinarian at our farm, and thus we can establish healthy and safe meat production.</p>
    <p style="text-align:left;">Ibachikuren Pilot Farm</p>
  </a-card>
</div>

<div style="width:100%;margin-top:5px;">
  <a-row flex justify="center">
    <wagyu-item v-for="witem in wagyuItems" :key="witem.item_code" :item="witem" />
  </a-row>
</div>
<!--
<div style="width:100%;margin-top:10px;">
  user info: {{$store.getters['userInfo/userInfo']['userData']['id']}}
</div>
-->

</section>
</template>
<script>
 // import Item from '@/views/Item.vue'
  import WagyuItem from '@/views/WagyuItem.vue'
  import { onMounted } from 'vue'
 // import axios from 'axios'
  export default {
    name: 'Category',
    components:{WagyuItem},
    emits: ['viewLoaded'],
    setup(props,ctx) {
        const wagyuItems = [
          {
            item_name: 'Wagyu Beef Striploin',
            item_code: 'LBS1011JP01',
            price: 115,
            unit:  'lb',
            weight: 'ave. 2.45~3.8 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef A4(BMS 5) Striploin,  Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lbs0005jp01.jpg'),
            part: require('../assets/products/wagyu/meat_loin.jpg')
          },
          {
            item_name: 'Wagyu Beef Rib Eye',
            item_code: 'LRE1011JP01',
            price: 109,
            unit:  'lb',
            weight: 'ave. 1.7~3.15 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef A4(BMS 5) Rib Eye (wCap), Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lre0005jp01.jpg'),
            part: require('../assets/products/wagyu/meat_rib.jpg')
          },
          {
            item_name: 'Wagyu Beef Chuck Roll',
            item_code: 'LCR1011JP01',
            price: 75,
            unit:  'lb',
            weight: 'ave. 4.15~5.8 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef A4(BMS 5) Chuck Roll (wo Neck), Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lcr0005jp01.jpg'),
            part: require('../assets/products/wagyu/meat_chuckroll.jpg')
          },
          {
            item_name: 'Wagyu Beef Flap Meat',
            item_code: 'LFM1011JP01',
            price: 89,
            unit:  'lb',
            weight: 'ave. 3.3 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef A4(BMS 5) Flap meat, Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lsr1011jp01.jpg'),
            part: require('../assets/products/wagyu/meat_loin.jpg')
          },
          {
            item_name: 'Wagyu Beef Short Rib',
            item_code: 'LSR1011JP01',
            price: 89,
            unit:  'lb',
            weight: 'ave. 1.7 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef A5(BMS 10-11) Short Rib, Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lsr1011jp01.jpg'),
            part: require('../assets/products/wagyu/meat_rib.jpg')
          },
          {
            item_name: 'Wagyu Beef Flat Iron',
            item_code: 'LFI1011JP01',
            price: 89,
            unit:  'lb',
            weight: 'ave. 3.0~3.95 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef Flat Iron, Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lbs1200jp01.jpg'),
            part: require('../assets/products/wagyu/meat_loin.jpg')
          },
      
          {
            item_name: 'Wagyu Beef Top Sirloin CAP',
            item_code: 'LST1011JP01',
            price: 61,
            unit:  'lb',
            weight: 'ave. 6.5 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef Top Sirloin CAP, Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lsl1011jp01.jpg'),
            part: require('../assets/products/wagyu/meat_loin.jpg')
          },
          {
            item_name: 'Wagyu Beef A5(BMS 10-11) Top Sirloin Butt',
            item_code: 'LST1011JP01',
            price: 61,
            unit:  'lb',
            weight: 'ave. 5.2 kg',
            origin: '日本',
            description: 'Boneless Wagyu Beef Top Sirloin Butt, Imported from Japan by Frobisher International Enterprise Ltd.',
            pic: require('../assets/products/wagyu/lsl1011jp01.jpg'),
            part: require('../assets/products/wagyu/meat_loin.jpg')
          },
         
        ]
        
        onMounted(() => {
          ctx.emit('viewLoaded','category')
        })
        return { wagyuItems }
    }
  };
</script>
<style lang="scss" scoped>
.ant-carousel {
  text-align: center;
  background: #364d79;
  overflow: hidden;

   .slick-slide {
    text-align: center;
    height: 160px;
    /*line-height: 160px;*/
    background: #364d79;
    overflow: hidden;
    img {
      width:100%;
    }
  }
  .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .custom-slick-arrow:before {
    display: none;
  }
  .custom-slick-arrow:hover {
    opacity: 0.5;
  }
  .anticon {
  margin-right: 6px;
  font-size: 24px;
  }
  .anticon:hover {color:#fff;}
  
  #components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  background: #7dbcea;
  color: #fff;
}
}
</style>